import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Element, scroller } from 'react-scroll';
import {
  find, first, map, indexOf, values, reduce, sortBy, pick, filter,
  without, concat, each, defer, camelCase, findIndex, sumBy,
} from 'lodash';
import numeral from 'numeral';
import Fa from 'react-fontawesome';
import { Dropdown, MenuItem, OverlayTrigger, Tooltip, ProgressBar } from 'react-bootstrap';
import ProgressBar2 from '../../../../components/progress-bar';
import { getColorFromKey, getTypeColorFromKey } from '../../../../util/helpers';
import styles from './styles.css';
import chartStyles from './chart-styles.css';
import MoneyDisplay from '../../../../components/money-display';
import NumberDisplay from '../../../../components/number-display';
import OwnerSelector from '../../../../components/owner-selector';
import TenureDisplay from '../../../../components/tenure-display';
import CircleGraph from '../../../../components/circle-graph';
import WindowResizeListener from '../../../../components/window-size-listener';

import { getUser } from '../../../Auth/AuthReducer';
import {
  getBenchmarkGraphOpportunities,
  getBenchmarkGraphLoading,
  getBenchmarkGraphLoaded,
  getBenchmarkGraphOwners,
  getBenchmarkGraphAverage,
  getBenchmarkGraphBestInClassCount,
  getBenchmarkGraphBestInClassAmount,
  getConversionGraphOwners,
  getStages,
} from '../../PipelineReducer';

const typeOptions = [
  { label: 'Amount', value: 'amount' },
  { label: 'Count', value: 'count' },
];
const stageOptions = [
  { label: 'Win Rate', value: 'Won' },
  { label: 'Loss Rate', value: 'Lost' },
  { label: 'No Decision Rate', value: 'No Decision' },
];
const dealTypeOptions = [
  { label: 'Renewal', value: 'Renewal' },
  { label: 'New Business', value: 'New business' },
  { label: 'Add-on', value: 'Add-on' },
  { label: 'Upsell', value: 'Upsell' },
];
const USER_PREFERENCE_REPORT_TYPE = 'pipeline-brenchmarkGraph-graph-report-type';

class BrenchmarkGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportType: 'amount',
      activeStages: map(stageOptions, 'value'),
      ownerId: props.defaultOwnerId,
      secondaryOwnerId: null,
      activeDealTypes: map(dealTypeOptions, 'value'),
      containerWidth: 0,
    };
    this.setReportType = this.setReportType.bind(this);
    this.handleChartClick = this.handleChartClick.bind(this);
    this.handleSelectOwner = this.handleSelectOwner.bind(this);
    this.handleSelectSecondaryOwner = this.handleSelectSecondaryOwner.bind(this);
    this.toggleDealType = this.toggleDealType.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);
  }

  componentWillMount() {
    const { userPreferences } = this.context;
    const reportType = userPreferences[USER_PREFERENCE_REPORT_TYPE] || 'amount';
    this.setState({ reportType });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.allOwners !== nextProps.allOwners && !this.props.defaultOwnerId) {
      let defaultOwnerId = null;
      if (nextProps.allOwners.length) {
        const o = nextProps.allOwners[0];
        defaultOwnerId = nextProps.allOwners.length > 0 ? o.user_id : null;
      }
      this.setState({ ownerId: defaultOwnerId });
    }
  }

  onWindowResize() {
    if (this.container) {
      const containerWidth = this.container.offsetWidth;
      this.setState({ containerWidth });
    }
  }

  setReportType(reportType) {
    this.setState({ reportType });
    this.context.updateUserPreference(USER_PREFERENCE_REPORT_TYPE, reportType);
  }

  getOwnerTooltip(owner, stage, isTotal = false) {
    const { reportType } = this.state;
    if (!owner || !stage) {
      return null;
    }
    if (isTotal) {
      return (
        <div>
          <strong>{owner.name}</strong> win probability rate
        </div>
      );
    }
    return reportType === 'amount' ?
      (
        <div>
          The amount <strong>{owner.name}</strong> wins based on trailing twelve month performance for opportunities in <strong>{stage.label}</strong>.
        </div>
      ) :
      (
        <div>
          The percentage of opportunities <strong>{owner.name}</strong> wins based on trailing twelve month performance for opportunities in <strong>{stage.label}</strong>.
        </div>
      );
  }

  getOwner(isHistory = false) {
    const { reportType, ownerId } = this.state;
    const {
      pipelineOwners, historyOwners, allOwners, bestInClassCount, bestInClassAmount,
    } = this.props;
    let userId = ownerId;
    if (!userId) {
      if (reportType === 'amount' && bestInClassAmount) {
        userId = bestInClassAmount.ownerId;
      } else if (reportType === 'count' && bestInClassCount) {
        userId = bestInClassCount.ownerId;
      }
    }
    if (isHistory) {
      return historyOwners[userId] || find(allOwners, { user_id: userId });
    }
    return pipelineOwners[userId] || find(allOwners, { user_id: userId });
  }

  getBicOwner(isHistory = false) {
    const { reportType, secondaryOwnerId } = this.state;
    const {
      pipelineOwners, historyOwners, allOwners, bestInClassCount, bestInClassAmount,
    } = this.props;
    let userId = secondaryOwnerId;
    if (!userId) {
      if (reportType === 'amount' && bestInClassAmount) {
        userId = bestInClassAmount.ownerId;
      } else if (reportType === 'count' && bestInClassCount) {
        userId = bestInClassCount.ownerId;
      }
    }
    if (isHistory) {
      return historyOwners[userId] || find(allOwners, { user_id: userId });
    }
    return pipelineOwners[userId] || find(allOwners, { user_id: userId });
  }


  handleChartClick(event) {
    this.props.onSelect(event.point.options.ids);
  }

  handleSelectOwner(owner) {
    this.setState({ ownerId: owner ? owner.user_id : null });
  }
  handleSelectSecondaryOwner(owner) {
    this.setState({ secondaryOwnerId: owner ? owner.user_id : null });
  }
  toggleDealType(dealType) {
    const { activeDealTypes } = this.state;
    let newActiveDealTypes = [...activeDealTypes];

    if (indexOf(newActiveDealTypes, dealType) >= 0) {
      newActiveDealTypes = without(newActiveDealTypes, dealType);
    } else {
      newActiveDealTypes = concat(newActiveDealTypes, dealType);
    }
    this.setState({ activeDealTypes: newActiveDealTypes });
    defer(() => {
      scroller.scrollTo('pipeline-benchmark-chart', { duration: 500, smooth: true, offset: -70 });
    });
  }

  toggleStage(stage) {
    const { activeStages } = this.state;
    let newActiveStages = [...activeStages];

    if (indexOf(newActiveStages, stage) >= 0) {
      // remove
      newActiveStages = without(newActiveStages, stage);
    } else {
      newActiveStages = concat(newActiveStages, stage);
    }
    this.setState({ activeStages: newActiveStages });
    defer(() => {
      scroller.scrollTo('pipeline-conversion-chart', { duration: 500, smooth: true, offset: -70 });
    });
  }

  renderControls() {
    const { reportType } = this.state;
    const activeType = find(typeOptions, { value: reportType }) || first(typeOptions);

    return (
      <h5 className="sub-header-with-controls">
        Analyze pipeline&nbsp;
        <Dropdown
          id="type-dropdown"
        >
          <Dropdown.Toggle bsSize="small">
            {activeType.label}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {typeOptions.map(s => (
              <MenuItem
                key={s.value}
                active={s.value === activeType.value}
                onSelect={() => { this.setReportType(s.value); }}
              >
                {s.label}
              </MenuItem>
              ))}
          </Dropdown.Menu>
        </Dropdown>
        &nbsp;and compare&nbsp;
        <OwnerSelector
          owners={this.props.allOwners}
          ownerId={this.state.ownerId}
          onSelect={this.handleSelectOwner}
          emptyText="Best In Class"
        />
        &nbsp;with&nbsp;
        <OwnerSelector
          owners={this.props.allOwners}
          ownerId={this.state.secondaryOwnerId}
          onSelect={this.handleSelectSecondaryOwner}
          emptyText="Best In Class"
        />
      </h5>
    );
  }

  renderOwnerCircle(owner, stage, otherOwner = null, isTotal = false) {
    if (!owner || !stage) {
      return;
    }
    const { reportType } = this.state;
    const ownerTooltip = this.getOwnerTooltip(owner, stage, isTotal);
    let percentage = reportType === 'amount' ? stage.amountProbabilityRate : stage.countProbabilityRate;
    if (isTotal) {
      percentage = reportType === 'amount' ? owner.winAmountProbabilityRate : owner.winCountProbabilityRate;
    }
    const title = numeral(percentage).format('0.0%');
    let color = '#2196f3';
    if (otherOwner) {
      let otherPercentage = 0;
      if (otherOwner.historyOwnerStage) {
        otherPercentage = reportType === 'amount' ? otherOwner.historyOwnerStage.amountProbabilityRate : otherOwner.historyOwnerStage.countProbabilityRate;
      }
      if (isTotal) {
        otherPercentage = reportType === 'amount' ? otherOwner.winAmountProbabilityRate : otherOwner.winCountProbabilityRate;
      }
      if (percentage > otherPercentage) {
        color = getColorFromKey('won');
      } else if (percentage < otherPercentage) {
        color = getColorFromKey('lost');
      }
    }
    return (
      <div className={`${chartStyles.circle} ${isTotal ? chartStyles.totalCircle : null}`}>
        <CircleGraph
          title={title}
          color={color}
          value={percentage}
          tooltip={ownerTooltip}
          subTitle={isTotal ? 'Win Rate' : 'Conversion Rate'}
          half
        />
      </div>
    );
  }

  renderStageBar(row, grandTotal) {
    const {
      isTotal, rowLabel, stage, rowType,
    } = row;
    if (!stage) {
      return null;
    }
    const { allOwners } = this.props;
    const { activeDealTypes, reportType, containerWidth } = this.state;
    const min = 50; // pixel
    const totalReps = allOwners.length;
    let total = 0;
    const bars = reduce(pick(stage.totalTypeStats, activeDealTypes), (items, typeStat, dealName) => {
      const value = typeStat[reportType] || 0;
      total += value;
      items.push({
        ids: typeStat.ids,
        name: dealName,
        percentage: 0,
        color: getTypeColorFromKey(dealName),
        value,
        count: typeStat.count,
        amount: typeStat.amount,
      });
      return items;
    }, []);
    const sortedBar = sortBy(bars, [(bar) => {
      if (bar.name === 'Renewal') {
        return 10;
      } else if (bar.name === 'New business') {
        return 100;
      } else if (bar.name === 'Add-on') {
        return 1000;
      } else if (bar.name === 'Upsell') {
        return 10000;
      }
      return 100000;
    }]);
    if (total !== 0) {
      each(sortedBar, (bar) => {
        bar.percentage = bar.value / total;
      });
    }
    const tip = (
      <Tooltip
        id={camelCase(`benchmark popover ${stage.value}`)}
        className={chartStyles.tooltip}
      >
        <div>
          <h1 className={chartStyles.tooltipTitle}>
            {rowLabel}
            {rowType === 'average' && totalReps > 0 && <sup>*</sup>}
          </h1>
          <h2 className={chartStyles.tooltipSubTitle}>
            {!isTotal && <span>Stage: {stage.label}</span>}
            {isTotal && <span>Total Pipeline</span>}
          </h2>
          <table className="table table-condensed">
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th className="text-right">Count</th>
                <th className="text-right">Amount</th>
                <th className="text-right">Percent</th>
              </tr>
            </thead>
            <tbody>
              {sortedBar.map(bar => (
                <tr key={bar.name}>
                  <td style={{ color: bar.color }}>
                    {bar.name} {bar.rowType}
                  </td>
                  <td className="text-right">
                    <NumberDisplay value={bar.count} precision={0} />
                  </td>
                  <td className="text-right">
                    <MoneyDisplay value={bar.amount} abbreviated precision={2} />
                  </td>
                  <td className="text-right">
                    <NumberDisplay value={bar.percentage * 100} precision={1} suffix="%" />
                  </td>
                </tr>
                ))}
            </tbody>
            {rowType === 'average' && totalReps > 0 &&
              <tfoot>
                <tr>
                  <td colSpan="4">
                    <sup>*</sup> Average pipeline {reportType} for <NumberDisplay value={totalReps} precision={0} suffix="sales representative" suffixIsUnit />
                  </td>
                </tr>
              </tfoot>
            }
          </table>
        </div>
      </Tooltip>
    );
    let projected = 1;
    if (typeof grandTotal === 'number') {
      projected = grandTotal !== 0 ? total / grandTotal : 0;
    }
    return [
      (
        <td key="label" className="text-right">
          <nobr>{row.rowLabel}</nobr>
        </td>
      ),
      (
        <td key="bars">
          {sortedBar.length > 0 &&
            <OverlayTrigger trigger={['hover']} placement="top" overlay={tip}>
              <ProgressBar
                className={chartStyles.progress}
              >
                {sortedBar.map((bar) => {
                  const now = bar.percentage * 100;
                  const label = numeral(bar.percentage).format('0.0%');
                  return (
                    <ProgressBar
                      now={now * projected}
                      label={bar.percentage * projected * containerWidth > min ? label : null}
                      key={bar.name}
                      style={{ backgroundColor: bar.color }}
                      onClick={() => {
                        this.props.onSelect(bar.ids);
                      }}
                    />
                  );
                })}
              </ProgressBar>
            </OverlayTrigger>
          }
          {sortedBar.length === 0 &&
            <ProgressBar
              className={chartStyles.progress}
            >
              <ProgressBar now={0} />
            </ProgressBar>
          }
        </td>
      ),
      (
        <td key="stack" className="text-right">
          <nobr>
            {reportType === 'amount' && <MoneyDisplay value={total} abbreviated precision={2} />}
            {reportType === 'count' && <NumberDisplay value={total} abbreviated precision={0} suffix="Deal" suffixIsUnit />}
          </nobr>
        </td>
      ),
    ];
  }

  renderChart() {
    const { reportType, activeDealTypes } = this.state;
    const { averageStages } = this.props;
    const owner = this.getOwner();
    const bicOwner = this.getBicOwner();
    const historyOwners = this.getOwner(true);
    const historyBicOwners = this.getBicOwner(true);

    const onwerStages = owner ? owner.stages : [];
    const bicOnwerStages = bicOwner ? bicOwner.stages : [];
    let maxTotal = 0;
    let maxTotalPipeline = 0;

    const pipelineItems = [
      {
        rowType: 'owner',
        rowLabel: owner ? owner.name : null,
        stageName: 'Total Pipeline',
        stage: { totalTypeStats: {} },
        historyOwnerStage: {},
        historyBicOwnerStage: {},
        id: 'total-pipeline-owner',
        isTotal: true,
      },
      {
        rowType: 'average',
        rowLabel: 'Average',
        stage: { totalTypeStats: {} },
        stageName: 'Total Pipeline',
        id: 'total-pipeline-average',
        isTotal: true,
      },
      {
        rowType: 'bicOwner',
        rowLabel: bicOwner ? bicOwner.name : null,
        stage: { totalTypeStats: {} },
        stageName: 'Total Pipeline',
        id: 'total-pipeline-bic-owner',
        isTotal: true,
      },
    ];
    const stages = reduce(this.props.stages, (items, allStage) => {
      const ownerStage = find(onwerStages, { value: allStage.value });
      const bicOwnerStage = find(bicOnwerStages, { value: allStage.value });
      const historyOwnerStage = find(historyOwners.stages, { value: allStage.value });
      const historyBicOwnerStage = historyBicOwners ? find(historyBicOwners.stages, { value: allStage.value }) : null;
      const averageStage = find(averageStages, { value: allStage.value });
      const statsTypes = [ownerStage, averageStage, bicOwnerStage];
      each(statsTypes, (statsType, index) => {
        if (statsType) {
          each(statsType.totalTypeStats, (dealTypeStat, dealType) => {
            if (!pipelineItems[index].stage.totalTypeStats[dealType]) {
              pipelineItems[index].stage.totalTypeStats[dealType] = { count: 0, amount: 0, id: [] };
            }
            pipelineItems[index].stage.totalTypeStats[dealType].count += dealTypeStat.count;
            pipelineItems[index].stage.totalTypeStats[dealType].amount += dealTypeStat.amount;
            pipelineItems[index].stage.totalTypeStats[dealType].ids = concat(pipelineItems[index].stage.totalTypeStats[dealType].ids, dealTypeStat.ids);
          });
          maxTotal = Math.max(maxTotal, sumBy(values(pick(statsType.totalTypeStats, activeDealTypes)), reportType));
          maxTotalPipeline = Math.max(maxTotalPipeline, sumBy(values(pick(pipelineItems[index].stage.totalTypeStats, activeDealTypes)), reportType));
        }
      });

      items.push({
        rowType: 'owner',
        rowLabel: owner ? owner.name : null,
        stageName: allStage.label,
        stage: ownerStage,
        historyOwnerStage,
        historyBicOwnerStage,
        id: camelCase(`owner ${allStage.stage_id}`),
      });
      items.push({
        rowType: 'average',
        rowLabel: 'Average',
        stage: averageStage,
        stageName: allStage.label,
        id: camelCase(`average ${allStage.stage_id}`),
      });
      items.push({
        rowType: 'bicOwner',
        rowLabel: bicOwner ? bicOwner.name : null,
        stage: bicOwnerStage,
        stageName: allStage.label,
        id: camelCase(`bic owner ${allStage.stage_id}`),
      });
      return items;
    }, []);

    stages.splice(0, 0, ...pipelineItems);

    stages.splice(0, 0, {
      rowType: 'total', id: 'total', total: 3, label: '',
    });
    const earlyStages = filter(stages, stage => stage.stage !== undefined && stage.stage.conversion_stage === 'early');
    const earlyStageIndex = findIndex(stages, stage => stage.stage !== undefined && stage.stage.conversion_stage === 'early');
    if (earlyStageIndex >= 0) {
      stages.splice(earlyStageIndex, 0, {
        rowType: 'early', id: 'early', total: earlyStages.length, label: 'Early Stages',
      });
    }

    const lateStages = filter(stages, stage => stage.stage !== undefined && stage.stage.conversion_stage === 'late');
    const lateStageIndex = findIndex(stages, stage => stage.stage !== undefined && stage.stage.conversion_stage === 'late');
    if (lateStageIndex >= 0) {
      stages.splice(lateStageIndex, 0, {
        rowType: 'late', id: 'late', total: lateStages.length, label: 'Late Stages',
      });
    }


    return (
      <div>
        <table className={`table table-condensed ${chartStyles.mainTable}`}>
          <thead>
            <tr>
              <th colSpan="3" />
              <th width="99%">
                <div ref={(el) => { this.container = el; }}>
                  <WindowResizeListener onResize={this.onWindowResize} />
                </div>
              </th>
              <th />
              <th width="80" className="text-center">{owner !== undefined && owner.name}</th>
              <th width="80" className="text-center">{bicOwner !== undefined && bicOwner.name}</th>
            </tr>
          </thead>
          <tbody>
            {stages.map((stage) => {
              const { rowType } = stage;
              if (rowType === 'early' || rowType === 'late' || rowType === 'total') {
                return [
                  (
                    <tr
                      key={`${stage.id}-0`}
                      className={`${chartStyles.divider} ${chartStyles.separateRow}`}
                    >
                      <td
                        colSpan={7}
                      >
                        &nbsp;
                      </td>
                    </tr>
                  ),
                  (
                    <tr
                      key={`${stage.id}-1`}
                      className={`${chartStyles.divider} ${chartStyles.separateRow}`}
                    >
                      <td
                        rowSpan={stage.total + 1}
                        className={chartStyles.groupColumn}
                      >
                        <span className={chartStyles.rotatedStage}>
                          <span className="label text-uppercase">
                            {stage.label}
                          </span>
                        </span>
                      </td>
                    </tr>
                  ),
                ];
              }
              const isFirstRow = rowType === 'owner';
              const isSkipped = stage.stage && stage.stage.skip_conversion;
              const cls = [];
              if (isFirstRow) {
                cls.push(chartStyles.divider);
              }
              if (stage.isTotal) {
                cls.push(chartStyles.totalRow);
              }
              if (isSkipped) {
                cls.push(chartStyles.skippedRow);
              }
              const skipTip = (
                <Tooltip
                  id={camelCase(`skipped ${stage.id}`)}
                  className={chartStyles.tooltip}
                >
                  <strong>{stage.stageName}</strong> stage is excluded from all calculations.
                </Tooltip>
              );

              return (
                <tr
                  key={stage.id}
                  className={cls.join(' ')}
                >
                  {isFirstRow && !isSkipped &&
                    <td rowSpan="3" style={{ verticalAlign: 'middle' }}>
                      <span className={chartStyles.stageName}>{stage.stageName}</span>
                    </td>
                  }
                  {!isSkipped && this.renderStageBar(stage, stage.isTotal ? maxTotalPipeline : maxTotal)}
                  {isSkipped && isFirstRow &&
                    <td colSpan="6">
                      <OverlayTrigger trigger={['hover']} placement="top" overlay={skipTip}>
                        <span className={`${chartStyles.stageName} text-muted`}>{stage.stageName} <Fa name="exclamation-triangle" /></span>
                      </OverlayTrigger>
                    </td>
                  }
                  {isFirstRow && !isSkipped &&
                    <td rowSpan="3" className="text-center">
                      {this.renderOwnerCircle(historyOwners, stage.historyOwnerStage, historyBicOwners, stage.isTotal)}
                    </td>
                  }
                  {isFirstRow && !isSkipped &&
                    <td rowSpan="3" className="text-center">
                      {this.renderOwnerCircle(historyBicOwners, stage.historyBicOwnerStage, null, stage.isTotal)}
                    </td>
                  }
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  renderStats() {
    const { reportType } = this.state;
    const owner = this.getOwner(true);
    const bicOwner = this.getBicOwner(true);
    if (!owner || !bicOwner) {
      return null;
    }
    const header = (
      <thead>
        <tr>
          <th className="text-center">
            {owner.name}
          </th>
          <th className="text-center">
            {bicOwner.name}
          </th>
        </tr>
      </thead>
    );
    const tenureTip = (
      <Tooltip
        id="stats-tenure-tip"
        className={chartStyles.tooltip}
      >
        <div>
          Displays sales tenure, which is calculated based on the length of time
          the sales rep&rsquo;s CRM license has been active,
          and the number of opportunities the rep has won in the last 12 months.
        </div>
      </Tooltip>
    );
    return (
      <div className={styles.stats}>
        <section className={`${styles.panel} panel panel-default animated bounceIn`}>
          <div className="panel-body">
            <h3>
              Sales Experience&nbsp;
              <OverlayTrigger trigger={['hover']} placement="top" overlay={tenureTip}>
                <Fa name="info-circle" className="text-active" />
              </OverlayTrigger>
            </h3>
            <table className="table table-condensed">
              {header}
              <tbody>
                <tr>
                  <td className={`text-center ${styles.statNumber}`}>
                    <TenureDisplay value={owner.tenures} />
                  </td>
                  <td className={`text-center ${styles.statNumber}`}>
                    <TenureDisplay value={bicOwner.tenures} />
                  </td>
                </tr>
                <tr>
                  <td className={`text-center ${styles.statNumber}`}>
                    <nobr><NumberDisplay value={owner.stats ? owner.stats.wonCount : 0} precision={0} /> of <NumberDisplay value={owner.stats ? owner.stats.count : 0} precision={0} /> won</nobr>
                  </td>
                  <td className={`text-center ${styles.statNumber}`}>
                    <nobr><NumberDisplay value={bicOwner.stats ? bicOwner.stats.wonCount : 0} precision={0} /> of <NumberDisplay value={bicOwner.stats ? bicOwner.stats.count : 0} precision={0} /> won</nobr>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {stageOptions.map((stageOption) => {
          const Comp = reportType === 'amount' ? MoneyDisplay : NumberDisplay;
          const options = reportType === 'amount' ? { precision: 1, abbreviated: true } : { precision: 0, suffix: 'Deal', suffixIsUnit: true };
          const tip = (
            <Tooltip
              id={`stats-${stageOption.value}-tips`}
              className={chartStyles.tooltip}
            >
              <div>
                {stageOption.label} and {reportType} are based on the trailing twelve months.
              </div>
            </Tooltip>
          );
          return (
            <section
              className={`${styles.panel} panel panel-default animated bounceIn`}
              key={stageOption.value}
            >
              <div className="panel-body">
                <h3 style={{ color: getColorFromKey(stageOption.value) }}>
                  {stageOption.label}&nbsp;
                  <OverlayTrigger trigger={['hover']} placement="top" overlay={tip}>
                    <Fa name="info-circle" className="text-active" />
                  </OverlayTrigger>
                </h3>
                <table className="table table-condensed">
                  {header}
                  <tbody>
                    <tr>
                      <td className={`text-center ${styles.statNumber}`}>
                        <NumberDisplay value={owner.stats ? owner.stats[camelCase(`${stageOption.value} ${reportType} Rate`)] * 100 : 0} precision={1} suffix="%" />
                      </td>
                      <td className={`text-center ${styles.statNumber}`}>
                        <NumberDisplay value={bicOwner.stats ? bicOwner.stats[camelCase(`${stageOption.value} ${reportType} Rate`)] * 100 : 0} precision={1} suffix="%" />
                      </td>
                    </tr>
                    <tr>
                      <td className={`text-center ${styles.statNumber}`}>
                        <nobr><Comp value={owner.stats ? owner.stats[camelCase(`${stageOption.value} ${reportType}`)] : 0} {...options} /></nobr>
                      </td>
                      <td className={`text-center ${styles.statNumber}`}>
                        <nobr><Comp value={bicOwner.stats ? bicOwner.stats[camelCase(`${stageOption.value} ${reportType}`)] : 0} {...options} /></nobr>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          );
        })}
      </div>
    );
  }

  renderDealTypeToggle() {
    const { activeDealTypes } = this.state;
    return (
      <div className={chartStyles.legend}>
        <ul>
          {dealTypeOptions.map((dealType) => {
            const active = indexOf(activeDealTypes, dealType.value) >= 0;
            return (
              <li
                className={active ? chartStyles.active : null}
                key={dealType.value}
                onClick={(e) => {  // eslint-disable-line
                  e.preventDefault();
                  e.stopPropagation();
                  this.toggleDealType(dealType.value);
                }}
              >
                <Fa name="circle" style={{ color: active ? getTypeColorFromKey(dealType.value) : null }} /> {dealType.label}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  render() {
    const { loading, loaded } = this.props;
    return (
      <div className={styles.chart}>
        {(loading || !loaded) && <ProgressBar2 />}
        {!loading && loaded &&
          <div>
            {this.renderControls()}
            {this.renderStats()}
            <Element name="pipeline-benchmark-chart" />
            {this.renderChart()}
            {this.renderDealTypeToggle()}
          </div>
        }
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const currentUser = getUser(state);
  const historyOwners = getConversionGraphOwners(state);
  const pipelineOwners = getBenchmarkGraphOwners(state);
  const allOwners = values({ ...pipelineOwners, ...historyOwners });
  let defaultOwnerId = null;
  if (currentUser && !currentUser.is_none_standard_user && currentUser.user_id) {
    if (find(allOwners, { user_id: currentUser.user_id })) {
      defaultOwnerId = currentUser.user_id;
    }
  }
  if (!defaultOwnerId && allOwners.length) {
    defaultOwnerId = allOwners[0].user_id;
  }
  return {
    stages: getStages(state),
    defaultOwnerId,
    loaded: getBenchmarkGraphLoaded(state),
    loading: getBenchmarkGraphLoading(state),
    opportunities: getBenchmarkGraphOpportunities(state),
    allOwners,
    historyOwners,
    pipelineOwners,
    averageStages: getBenchmarkGraphAverage(state),
    bestInClassCount: getBenchmarkGraphBestInClassCount(state),
    bestInClassAmount: getBenchmarkGraphBestInClassAmount(state),
  };
}

BrenchmarkGraph.propTypes = {
  dispatch: PropTypes.func.isRequired,
  loaded: PropTypes.bool,
  loading: PropTypes.bool,
  query: PropTypes.shape({}),
  defaultOwnerId: PropTypes.string,
  bestInClassCount: PropTypes.shape({}),
  bestInClassAmount: PropTypes.shape({}),
  historyOwners: PropTypes.shape({}),
  pipelineOwners: PropTypes.shape({}),
  onSelect: PropTypes.func,
  stages: PropTypes.arrayOf(PropTypes.shape({})),
  averageStages: PropTypes.arrayOf(PropTypes.shape({})),
  allOwners: PropTypes.arrayOf(PropTypes.shape({})),
};

BrenchmarkGraph.defaultProps = {
  loaded: false,
  loading: false,
  query: null,
  defaultOwnerId: null,
  onSelect: () => {},
  allOwners: [],
  averageStages: [],
  bestInClassCount: null,
  bestInClassAmount: null,
  pipelineOwners: {},
  historyOwners: {},
  stages: [],
};
BrenchmarkGraph.contextTypes = {
  updateUserPreference: PropTypes.func.isRequired,
  userPreferences: PropTypes.shape({}).isRequired,
  addNotification: PropTypes.func.isRequired,
};
export default connect(mapStateToProps)(BrenchmarkGraph);
